var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownSmallGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons_Back_circle",
    "data-name": "Icons/Back circle",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M0,6.875,6.753,13.75l.842-.827L1.656,6.875,7.6.826,6.753,0Z",
    transform: "translate(0 7.596) rotate(-90)",
    fill: "#6e6e6e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Icons_Arrow_down_background",
    "data-name": "Icons/Arrow down background",
    width: 15,
    height: 15,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    transform: "translate(0.673 3.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M0,6.875,6.753,13.75l.842-.827L1.656,6.875,7.6.826,6.753,0Z",
    transform: "translate(0 7.596) rotate(-90)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_2",
    "data-name": "Enmascarar grupo 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue",
    "data-name": "Color/Liberty Blue",
    transform: "translate(-24.423 -27.452)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 62.5,
    height: 62.5,
    fill: "#6e6e6e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownSmallGray);
export default __webpack_public_path__ + "static/media/arrow-down-small-gray.5b6fcfafc60c1e9617b6a4d3d592d915.svg";
export { ForwardRef as ReactComponent };